import styled from 'styled-components';

export const StyledLink = styled.a`
    color: rgba(255,255,255,0.5);
    text-decoration: none;
    cursor: pointer;
`;